var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "box",
    { attrs: { content: "" } },
    [
      _c("base-carousel", {
        class: ["gfu-testimonial-slider gfu-testimonial-slider--wide"],
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ onAction, currentItem }) {
              return _vm._l(_vm.testimonials, function (item, index) {
                return _c(
                  "testimonials-slider-item",
                  _vm._b(
                    {
                      key: item.name,
                      class: [
                        "gfu-base-carousel-slide",
                        { "is-active": index === currentItem },
                      ],
                      on: { click: onAction },
                    },
                    "testimonials-slider-item",
                    item,
                    false
                  )
                )
              })
            },
          },
          {
            key: "indicators",
            fn: function ({ onSetCurrentIndex, currentItem }) {
              return [
                _c(
                  "nav",
                  { staticClass: "gfu-base-carousel-indicators" },
                  _vm._l(_vm.testimonials, function (item, index) {
                    return _c(
                      "a",
                      {
                        key: index,
                        class: [
                          "gfu-base-carousel-indicators__indicator",
                          { "is-active": index === currentItem },
                        ],
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return onSetCurrentIndex(index)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(index) +
                            "\n                "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]
            },
          },
          {
            key: "nav",
            fn: function ({ onNext, onPrev }) {
              return [
                _c("span", {
                  staticClass: "gfu-testimonial-slider-nav",
                  on: { click: onPrev },
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "gfu-testimonial-slider-nav",
                  on: { click: onNext },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }